import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import fetch from "./shared/Fetch";
import AppHeading from "./sharedComponents/AppHeading";
import AuthorizedContent from "./sharedComponents/AuthorizedContent";
import { ReactComponent as PlusIcon } from "./svgs/PlusIcon.svg";
import { ReactComponent as RemoveIcon } from "./svgs/RemoveConsultantIcon.svg";

const GroupsContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 2rem 2rem 9rem;
  color: var(--color-grey);
  height: 90vh;
  overflow: hidden;
`;

const GroupsListPanel = styled.div`
  flex: 0 0 33%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-top: 4%;
`;

const GroupsDetailPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-top: 4%;
  padding-left: 3rem;
  margin-left: 2rem;
  overflow: hidden;
`;

const GroupListContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow-y: auto;
  padding-bottom: 1rem;
`;

const AreaBox = styled.div`
  background: ${props => (props.unassigned ? "#fdecea" : "#f4f4f4")};
  border-radius: 0.5rem;
  padding: 1rem;
`;

const AreaBoxTitle = styled.h3`
  font-size: 1rem;
  font-weight: bold;
  margin: 0 0 0.8rem 0;
  color: var(--color-grey);
`;

const GroupCard = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  text-align: left;
  background: ${props =>
    props.selected ? "var(--theme-active-indicator)" : "white"};
  color: ${props => (props.selected ? "white" : "var(--color-grey)")};
  border: 1px solid
    ${props => (props.selected ? "var(--theme-active-indicator)" : "#ddd")};
  border-radius: 0.3rem;
  padding: 0.6rem 0.8rem;
  margin-bottom: 0.5rem;
  cursor: pointer;
  font-size: 0.95rem;
  transition: border-color 100ms, background 100ms;
  &:hover {
    border-color: var(--theme-active-indicator);
  }
  &:focus {
    outline: none;
  }
`;

const AddGroupPlaceholder = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: transparent;
  border: 2px dashed #ccc;
  border-radius: 0.3rem;
  padding: 0.6rem 0.8rem;
  margin-bottom: 0.5rem;
  cursor: pointer;
  font-size: 1.2rem;
  color: #aaa;
  &:hover {
    border-color: #999;
    color: #999;
  }
`;

const GroupSectionContainer = styled.div`
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
`;

const MemberBox = styled.div`
  background: #f4f4f4;
  border-radius: 0.5rem;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
`;

const MemberScroll = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

const MemberBoxTitle = styled.h3`
  font-size: 0.85rem;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-lightergrey);
  margin: 0 0 0.8rem 0;
`;

const AddListTitle = styled.h3`
  font-size: 0.85rem;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-lightergrey);
  margin: 0 0 0.8rem 0;
`;

const ConsultantList = styled.ul`
  list-style: none;

  background: ${props => (props.isempty ? " #F4F4F4" : "none")};
  display: ${props => (props.isempty ? "grid" : "block")};
  align-items: ${props => (props.isempty ? "center" : "start")};
  padding: ${props => (props.isempty ? "1rem" : "0")};
  margin-left: ${props => (props.isempty ? "40px" : "0")};
  border-radius: 1rem;

  & p {
    text-align: ${props => (props.isempty ? "center" : "start")};
    font-size: 0.9rem;
    color: #3a3a3a;
  }
`;

const ConsultantButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 0.95rem;
  display: grid;
  align-items: center;
  color: var(--color-grey);
  padding-bottom: 0.4rem;
  grid-template-columns: 20px 1fr;
  gap: 8px;

  &:hover {
    color: ${props =>
      props.isExistingMember
        ? "var(--button-abort-color)"
        : "var(--button-secondary-color)"};

    & span {
      text-decoration: unset;
      visibility: visible;
    }
  }

  &:focus {
    outline: none;
  }

  & span {
    text-decoration: unset;
    visibility: hidden;
  }
`;

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
`;

const SearchInput = styled.input`
  padding: 0.6rem 0.8rem;
  font-size: 1rem;
  border: 1px solid #b7b7b7;
  border-radius: 0.5rem;
  margin: 0 0 1rem 0;

  &:focus {
    border: 2px var(--theme-active-indicator) solid;
    outline: none;
  }
`;

const AddMemberIconStyled = styled(PlusIcon)`
  height: 0.7rem;
  width: 0.7rem;

  & * {
    fill: var(--button-secondary-color);
  }
`;

const RemoveMemberIconStyled = styled(RemoveIcon)`
  height: 0.8rem;
  width: 0.8rem;

  & * {
    fill: var(--button-abort-color);
  }
`;

const KanbanContainer = styled.div`
  padding: 2rem 2rem 2rem 9rem;
  display: flex;
  gap: 1.5rem;
  overflow-x: auto;
  min-height: 60vh;
  align-items: flex-start;
`;

const KanbanColumn = styled.div`
  flex: 1;
  min-width: 180px;
  background: ${props =>
    props.dragover
      ? "var(--table-available)"
      : props.unassigned
      ? "#fdecea"
      : "#f4f4f4"};
  border-radius: 0.5rem;
  padding: 1rem;
  transition: background 150ms;
`;

const KanbanColumnTitle = styled.h3`
  font-size: 1rem;
  font-weight: bold;
  margin: 0 0 1rem 0;
  color: var(--color-grey);
`;

const KanbanCard = styled.div`
  background: white;
  border: 1px solid #ddd;
  border-radius: 0.3rem;
  padding: 0.6rem 0.8rem;
  margin-bottom: 0.5rem;
  cursor: grab;
  font-size: 0.95rem;
  user-select: none;
  opacity: ${props => (props.dragging ? 0.4 : 1)};
  &:active {
    cursor: grabbing;
  }
`;

const KanbanColumnHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

const KanbanTitleInput = styled.input`
  font-size: 1rem;
  font-weight: bold;
  color: var(--color-grey);
  border: none;
  border-bottom: 2px solid var(--theme-active-indicator);
  background: transparent;
  padding: 0;
  width: 100%;
  &:focus {
    outline: none;
  }
`;

const KanbanDeleteButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--button-abort-color);
  font-size: 0.8rem;
  padding: 0 0.2rem;
  opacity: 0.5;
  &:hover {
    opacity: 1;
  }
  &:focus {
    outline: none;
  }
`;

const DeleteConfirm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  font-size: 0.8rem;
`;

const DeleteConfirmText = styled.span`
  color: var(--button-abort-color);
  font-weight: bold;
`;

const DeleteConfirmButtons = styled.div`
  display: flex;
  gap: 0.4rem;
`;

const DeleteConfirmYes = styled.button`
  background: var(--button-abort-color);
  color: white;
  border: none;
  border-radius: 0.2rem;
  padding: 0.2rem 0.6rem;
  cursor: pointer;
  font-size: 0.8rem;
  &:focus {
    outline: none;
  }
`;

const DeleteConfirmNo = styled.button`
  background: transparent;
  border: 1px solid #ccc;
  border-radius: 0.2rem;
  padding: 0.2rem 0.6rem;
  cursor: pointer;
  font-size: 0.8rem;
  color: var(--color-grey);
  &:focus {
    outline: none;
  }
`;

const AddAreaPlaceholder = styled.button`
  flex: 0 0 160px;
  min-height: 80px;
  background: transparent;
  border: 2px dashed #ccc;
  border-radius: 0.5rem;
  cursor: pointer;
  color: #aaa;
  font-size: 1.8rem;
  align-self: flex-start;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 150ms, color 150ms;
  &:hover {
    border-color: var(--theme-active-indicator);
    color: var(--theme-active-indicator);
  }
  &:focus {
    outline: none;
    border-color: var(--theme-active-indicator);
  }
`;

const TabRow = styled.div`
  display: flex;
  gap: 1rem;
  padding: 0 0 0 9rem;
  margin-bottom: 1rem;
`;

const Tab = styled.button`
  background: transparent;
  border: none;
  border-bottom: 2px solid
    ${props => (props.active ? "var(--theme-active-indicator)" : "transparent")};
  font-size: 1rem;
  font-weight: ${props => (props.active ? "bold" : "normal")};
  color: var(--color-grey);
  cursor: pointer;
  padding: 0.4rem 0;
  &:focus {
    outline: none;
  }
`;

const Groups = props => {
  const allFetchedConsultants = useRef([]);
  const [waitingForData, setWaitingForData] = useState(false);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState({});
  const [activeTab, setActiveTab] = useState("tjenester");
  const [serviceAreas, setServiceAreas] = useState([]);
  const [dragOverAreaId, setDragOverAreaId] = useState(null);
  const [editingAreaId, setEditingAreaId] = useState(null);
  const [editingAreaName, setEditingAreaName] = useState("");
  const [confirmDeleteAreaId, setConfirmDeleteAreaId] = useState(null);
  const [editingGroupId, setEditingGroupId] = useState(null);
  const [editingGroupName, setEditingGroupName] = useState("");
  const [confirmDeleteGroupId, setConfirmDeleteGroupId] = useState(null);
  const [memberList, setMemberList] = useState([]);
  const [notMemberList, setNotMemberList] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isAdminChecked, setIsAdminChecked] = useState(false);
  const [consultantSearch, setConsultantSearch] = useState("");

  useEffect(() => {
    filterConsultants(selectedGroup);
  }, [selectedGroup, selectedGroup.members, waitingForData, groups]);

  useEffect(() => {
    // Reset consultant search when switching groups
    setConsultantSearch("");
  }, [selectedGroup.id]);

  useEffect(() => {
    fetchGroupsAndConsultants();
    fetchCurrentUser();
    fetchServiceAreas();
  }, []);

  const fetchServiceAreas = async () => {
    try {
      const response = await fetch(`/serviceareas`);
      setServiceAreas(response);
    } catch (err) {
      console.log("Could not fetch service areas", err);
    }
  };

  const createServiceArea = async () => {
    const result = await fetch(`/serviceareas`, {
      method: "POST",
      body: JSON.stringify({ name: "Nytt tjenesteområde" })
    });
    if (result && result.id) {
      setServiceAreas(prev => [...prev, { id: result.id, name: result.name }]);
      setEditingAreaId(result.id);
      setEditingAreaName("");
    }
  };

  const renameServiceArea = async id => {
    const name = editingAreaName.trim();
    setEditingAreaId(null);
    if (!name) return;
    await fetch(`/serviceareas/${id}`, {
      method: "PUT",
      body: JSON.stringify({ name })
    });
    setServiceAreas(prev =>
      prev.map(sa => (sa.id === id ? { ...sa, name } : sa))
    );
  };

  const deleteServiceArea = async id => {
    await fetch(`/serviceareas/${id}`, { method: "DELETE" });
    setConfirmDeleteAreaId(null);
    setServiceAreas(prev => prev.filter(sa => sa.id !== id));
  };

  const handleDragStart = (e, groupId) => {
    e.dataTransfer.setData("groupId", groupId);
  };

  const handleDrop = (e, serviceAreaId) => {
    e.preventDefault();
    setDragOverAreaId(null);
    const groupId = e.dataTransfer.getData("groupId");
    if (!groupId) return;

    setGroups(prev =>
      prev.map(g => (g.id === groupId ? { ...g, serviceAreaId } : g))
    );

    fetch(`/groups/${groupId}`, {
      method: "PUT",
      body: JSON.stringify({ serviceAreaId: serviceAreaId || null })
    }).catch(err => console.log("Could not update service area", err));
  };

  const fetchCurrentUser = async () => {
    try {
      const user = await fetch(`/user/current`);
      if (user.admin) setIsAdmin(true);
      setIsAdminChecked(true);
    } catch (err) {
      console.log("Error fetching current user", err);
      setIsAdminChecked(true);
    }
  };

  const fetchGroupsAndConsultants = async () => {
    setWaitingForData(true);
    try {
      const response = await fetch(`/groups`);
      const mapped = response.map(group => {
        return { ...group, members: [] };
      });
      setGroups(mapped);
      fetchAllConsultants(mapped);
    } catch (err) {
      setWaitingForData(false);
      console.log("Request resulted in an error", err);
    }
  };

  const fetchAllConsultants = async groups => {
    try {
      const response = await fetch(`/consultants/`);
      allFetchedConsultants.current = response.sort((a, b) => {
        return a.name < b.name ? -1 : 1;
      });
      if (groups && groups.length > 0) {
        const mappedGroups = groups.map(group => ({
          ...group,
          members: response
            .filter(consultant =>
              consultant.groups.find(g => g.id === group.id)
            )
            .sort((a, b) => {
              return a.name < b.name ? -1 : 1;
            })
        }));
        setGroups(mappedGroups);
        if (!selectedGroup || !selectedGroup.name) {
          setSelectedGroup(mappedGroups[0]);
        }
      }
      setWaitingForData(false);
    } catch (err) {
      setWaitingForData(false);
      console.log("Request resulted in an error", err);
    }
  };

  const filterConsultants = () => {
    if (selectedGroup && selectedGroup.members) {
      const filteredConsultants = allFetchedConsultants.current
        .filter(
          consultant =>
            selectedGroup.members.findIndex(
              member => member.consultantId === consultant.consultantId
            ) < 0
        )
        .sort((a, b) => {
          return a.name < b.name ? -1 : 1;
        });
      setNotMemberList(filteredConsultants);
      setMemberList(
        selectedGroup.members.sort((a, b) => {
          return a.name < b.name ? -1 : 1;
        })
      );
    } else {
      setNotMemberList(allFetchedConsultants.current);
      setMemberList([]);
    }
  };

  // Derived filtered list for the "Legg til flere" section based on search query
  const filteredNotMemberList = notMemberList.filter(c =>
    (c.name || "")
      .toLowerCase()
      .includes((consultantSearch || "").toLowerCase())
  );

  const removeConsultantGroupConnection = consultantId => {
    if (!consultantId || !selectedGroup.id) {
      return;
    }
    const storedGroup = groups.find(group => group.id === selectedGroup.id);

    const newMembers = storedGroup.members
      .filter(consultant => consultant.consultantId !== consultantId)
      .sort((a, b) => {
        return a.name < b.name ? -1 : 1;
      });

    const updatedGroups = groups.map(group =>
      group.id === storedGroup.id ? { ...group, members: newMembers } : group
    );

    storedGroup.members = newMembers;
    setGroups(updatedGroups);
    setSelectedGroup(storedGroup);

    fetch(
      `/consultants/${consultantId}/group
    `,
      {
        method: "DELETE",
        body: JSON.stringify({
          groupId: selectedGroup.id
        })
      }
    );
  };

  const postConsultantGroupConnection = consultantId => {
    const storedGroup = groups.find(group => group.id === selectedGroup.id);

    const addedConsultant = allFetchedConsultants.current.find(
      consultant => consultant.consultantId === consultantId
    );

    storedGroup.members.push(addedConsultant);
    const newMembers = storedGroup.members.sort((a, b) => {
      return a.name < b.name ? -1 : 1;
    });
    const updatedGroups = groups.map(group =>
      group.id === storedGroup.id ? { ...group, members: newMembers } : group
    );

    setGroups(updatedGroups);
    setSelectedGroup(storedGroup);

    if (!consultantId || !selectedGroup.id) {
      return;
    }
    fetch(
      `/consultants/${consultantId}/group
    `,
      {
        method: "POST",
        body: JSON.stringify({
          groupId: selectedGroup.id
        })
      }
    );
  };

  const saveGroupName = id => {
    const name = editingGroupName.trim();
    setEditingGroupId(null);
    if (!name) return;
    fetch(`/groups/${id}`, {
      method: "PUT",
      body: JSON.stringify({ name })
    }).then(() => {
      setGroups(prev => prev.map(g => (g.id === id ? { ...g, name } : g)));
      if (selectedGroup.id === id)
        setSelectedGroup(prev => ({ ...prev, name }));
    });
  };

  const createGroup = async () => {
    const result = await fetch(`/groups`, {
      method: "POST",
      body: JSON.stringify({ name: "Ny tjeneste" })
    });
    if (result && result.generatedId) {
      const newGroup = {
        id: result.generatedId,
        name: "Ny tjeneste",
        members: []
      };
      setGroups(prev => [...prev, newGroup]);
      setSelectedGroup(newGroup);
      setEditingGroupId(result.generatedId);
      setEditingGroupName("");
    }
  };

  const deleteGroup = (group = selectedGroup) => {
    const groupId = group.id;
    const newGroups = groups.filter(g => g.id !== groupId);
    setGroups(newGroups);
    if (selectedGroup.id === groupId) setSelectedGroup(newGroups[0] || {});
    fetch(`/groups/${groupId}`, { method: "DELETE" });
  };

  const unassignedAreaId = "__unassigned__";
  const allColumns = [
    ...serviceAreas,
    { id: unassignedAreaId, name: "Ingen tilknytning" }
  ];

  const kanbanContent = (
    <KanbanContainer>
      {allColumns.map(area => {
        const isUnassigned = area.id === unassignedAreaId;
        const areaGroups = groups.filter(g =>
          isUnassigned ? !g.serviceAreaId : g.serviceAreaId === area.id
        );
        return (
          <KanbanColumn
            key={area.id}
            dragover={dragOverAreaId === area.id}
            unassigned={isUnassigned}
            onDragOver={e => {
              e.preventDefault();
              setDragOverAreaId(area.id);
            }}
            onDragLeave={() => setDragOverAreaId(null)}
            onDrop={e => handleDrop(e, isUnassigned ? null : area.id)}
          >
            <KanbanColumnHeader>
              {!isUnassigned && editingAreaId === area.id ? (
                <KanbanTitleInput
                  autoFocus
                  value={editingAreaName}
                  onChange={e => setEditingAreaName(e.target.value)}
                  onBlur={() => renameServiceArea(area.id)}
                  onKeyDown={e => {
                    if (e.key === "Enter") renameServiceArea(area.id);
                    if (e.key === "Escape") setEditingAreaId(null);
                  }}
                />
              ) : (
                <KanbanColumnTitle
                  style={isUnassigned ? {} : { cursor: "pointer" }}
                  onClick={() => {
                    if (isUnassigned) return;
                    setEditingAreaId(area.id);
                    setEditingAreaName(area.name);
                  }}
                  title={isUnassigned ? undefined : "Klikk for å endre navn"}
                >
                  {area.name}
                </KanbanColumnTitle>
              )}
              {!isUnassigned && areaGroups.length === 0 && (
                <KanbanDeleteButton
                  onClick={() => setConfirmDeleteAreaId(area.id)}
                  title="Slett tjenesteområde"
                >
                  ✕
                </KanbanDeleteButton>
              )}
            </KanbanColumnHeader>
            {!isUnassigned &&
              areaGroups.length === 0 &&
              confirmDeleteAreaId === area.id && (
                <DeleteConfirm>
                  <DeleteConfirmText>Slett området?</DeleteConfirmText>
                  <DeleteConfirmButtons>
                    <DeleteConfirmYes
                      onClick={() => deleteServiceArea(area.id)}
                    >
                      Slett
                    </DeleteConfirmYes>
                    <DeleteConfirmNo
                      onClick={() => setConfirmDeleteAreaId(null)}
                    >
                      Avbryt
                    </DeleteConfirmNo>
                  </DeleteConfirmButtons>
                </DeleteConfirm>
              )}
            {areaGroups.map(group => (
              <KanbanCard
                key={group.id}
                draggable
                onDragStart={e => handleDragStart(e, group.id)}
              >
                {group.name}
              </KanbanCard>
            ))}
          </KanbanColumn>
        );
      })}
      <AddAreaPlaceholder
        onClick={createServiceArea}
        title="Legg til tjenesteområde"
      >
        +
      </AddAreaPlaceholder>
    </KanbanContainer>
  );

  const adminContent = (
    <>
      <TabRow>
        <Tab
          active={activeTab === "tjenester"}
          onClick={() => setActiveTab("tjenester")}
        >
          Tjenester
        </Tab>
        <Tab
          active={activeTab === "tjenesteomrader"}
          onClick={() => setActiveTab("tjenesteomrader")}
        >
          Tjenesteområder
        </Tab>
      </TabRow>
      {activeTab === "tjenesteomrader" ? kanbanContent : null}
      <GroupsContainer
        style={{ display: activeTab === "tjenester" ? undefined : "none" }}
      >
        <GroupsListPanel>
          <GroupListContainer>
            {[
              ...serviceAreas,
              {
                id: "__unassigned__",
                name: "Ingen tilknytning",
                unassigned: true
              }
            ].map(area => {
              const areaGroups = groups.filter(g =>
                area.id === "__unassigned__"
                  ? !g.serviceAreaId
                  : g.serviceAreaId === area.id
              );
              if (areaGroups.length === 0 && area.id !== "__unassigned__")
                return null;
              return (
                <AreaBox key={area.id} unassigned={area.unassigned}>
                  <AreaBoxTitle>{area.name}</AreaBoxTitle>
                  {areaGroups.map((group, i) => {
                    const isEmpty =
                      !group.members || group.members.length === 0;
                    return (
                      <div key={group.id + "" + i}>
                        <GroupCard
                          selected={selectedGroup.id === group.id}
                          onClick={() => setSelectedGroup(group)}
                        >
                          {editingGroupId === group.id ? (
                            <KanbanTitleInput
                              autoFocus
                              value={editingGroupName}
                              onChange={e =>
                                setEditingGroupName(e.target.value)
                              }
                              onBlur={() => saveGroupName(group.id)}
                              onKeyDown={e => {
                                if (e.key === "Enter") saveGroupName(group.id);
                                if (e.key === "Escape") setEditingGroupId(null);
                              }}
                              onClick={e => e.stopPropagation()}
                            />
                          ) : (
                            <span
                              style={{ flex: 1 }}
                              onDoubleClick={e => {
                                e.stopPropagation();
                                setSelectedGroup(group);
                                setEditingGroupId(group.id);
                                setEditingGroupName(group.name);
                              }}
                              title="Dobbeltklikk for å endre navn"
                            >
                              {group.name}
                            </span>
                          )}
                          {isEmpty && editingGroupId !== group.id && (
                            <KanbanDeleteButton
                              onClick={e => {
                                e.stopPropagation();
                                setConfirmDeleteGroupId(group.id);
                              }}
                              title="Slett tjeneste"
                            >
                              ✕
                            </KanbanDeleteButton>
                          )}
                        </GroupCard>
                        {confirmDeleteGroupId === group.id && (
                          <DeleteConfirm>
                            <DeleteConfirmText>
                              Slett tjenesten?
                            </DeleteConfirmText>
                            <DeleteConfirmButtons>
                              <DeleteConfirmYes
                                onClick={() => {
                                  deleteGroup(group);
                                  setConfirmDeleteGroupId(null);
                                }}
                              >
                                Slett
                              </DeleteConfirmYes>
                              <DeleteConfirmNo
                                onClick={() => setConfirmDeleteGroupId(null)}
                              >
                                Avbryt
                              </DeleteConfirmNo>
                            </DeleteConfirmButtons>
                          </DeleteConfirm>
                        )}
                      </div>
                    );
                  })}
                  {area.id === "__unassigned__" && (
                    <AddGroupPlaceholder
                      onClick={createGroup}
                      title="Ny tjeneste"
                    >
                      +
                    </AddGroupPlaceholder>
                  )}
                </AreaBox>
              );
            })}
          </GroupListContainer>
        </GroupsListPanel>

        <GroupsDetailPanel>
          {notMemberList.length > 0 || memberList.length > 0 ? (
            <>
              <GroupSectionContainer>
                <MemberBox>
                  <MemberBoxTitle>
                    {memberList.length}{" "}
                    {memberList.length === 1 ? "medlem" : "medlemmer"}
                  </MemberBoxTitle>
                  <MemberScroll>
                    <ConsultantList
                      isempty={memberList && memberList.length === 0}
                    >
                      {memberList && memberList.length === 0 && (
                        <p>Ingen medlemmer enda.</p>
                      )}
                      {memberList &&
                        memberList.map((consultant, i) => (
                          <li key={consultant.id + "" + i}>
                            <ConsultantButton
                              isExistingMember={true}
                              onClick={() =>
                                removeConsultantGroupConnection(
                                  consultant.consultantId
                                )
                              }
                            >
                              <span>
                                <RemoveMemberIconStyled />
                              </span>
                              {consultant.name}
                            </ConsultantButton>
                          </li>
                        ))}
                    </ConsultantList>
                  </MemberScroll>
                </MemberBox>
                <ListContainer>
                  <AddListTitle>Legg til</AddListTitle>
                  <SearchInput
                    type="text"
                    value={consultantSearch}
                    onChange={e => setConsultantSearch(e.target.value)}
                    placeholder="Søk..."
                    aria-label="Søk etter ansatt"
                  />
                  <MemberScroll>
                    <ConsultantList
                      isempty={filteredNotMemberList.length === 0}
                    >
                      {filteredNotMemberList.length === 0 &&
                        (notMemberList.length === 0 ? (
                          <p>Alle ansatte er med i tjenesten.</p>
                        ) : (
                          <p>Ingen ansatte funnet.</p>
                        ))}
                      {filteredNotMemberList.map((consultant, i) => (
                        <li key={consultant.consultantId + "" + i}>
                          <ConsultantButton
                            onClick={() =>
                              postConsultantGroupConnection(
                                consultant.consultantId
                              )
                            }
                          >
                            <span>
                              <AddMemberIconStyled />
                            </span>
                            {consultant.name}
                          </ConsultantButton>
                        </li>
                      ))}
                    </ConsultantList>
                  </MemberScroll>
                </ListContainer>
              </GroupSectionContainer>
            </>
          ) : (
            <></>
          )}
        </GroupsDetailPanel>
      </GroupsContainer>
    </>
  );

  return (
    <div className="module">
      <AppHeading
        departments={props.match.params.departments}
        offset={0}
        weeks={8}
        availableOnly={props.match.params.availableOnly}
        seniorities={props.match.params.seniorities}
        serviceareas={props.match.params.serviceareas}
        active={"groups"}
      />

      <AuthorizedContent
        isLoading={waitingForData || !isAdminChecked}
        isAuthorized={isAdmin}
        authorizedContent={adminContent}
        unauthorizedMessage="Du har ikke tilstrekkelige rettigheter til å administrere tjenester."
      />
    </div>
  );
};

export default Groups;
